// src/pages/PrivacyPolicy.js
import React from 'react';
import '../styles/PrivacyPolicy.css'; // Import CSS for styling

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <h1>Privacy Policy</h1>

      <p>Effective Date: 28 April 2025</p>

      <p>EdGeneOnline ("we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website https://www.edgeneonline.com and use our services.</p>

      <h2>Information We Collect</h2>

      <p>We collect several types of information from and about users of our website, including:</p>

      <h3>Personal Information</h3>
      <ul>
          <li><strong>Email Address:</strong> We collect your email address when you sign up for an account.</li>
          <li><strong>Name and Surname:</strong> We collect your name and surname during the signup process.</li>
          <li><strong>City/Town:</strong> We collect your current city or town during signup.</li>
          <li><strong>Cell Number:</strong> We collect your cell number during signup.</li>
      </ul>

      <h3>Payment Information</h3>
      <ul>
          <li>We use Paystack to process payments. We do not directly collect or store your payment details (e.g., credit card numbers). All payment information is handled securely by Paystack.</li>
      </ul>

      <h3>Voucher Information</h3>
      <ul>
          <li>We generate and store voucher codes in our Azure Cosmos DB database. These codes are linked to your email address.</li>
      </ul>

      <h3>Usage Data</h3>
      <ul>
          <li><strong>Payment Status:</strong> We store your payment status locally in your browser (using localStorage) to manage access to paid features.</li>
          <li><strong>Paid Plan:</strong> We store information about your selected paid plan locally in your browser (using localStorage) to manage access to paid features.</li>
          <li><strong>Reference:</strong> We generate a unique reference for each payment and store it locally in your browser (using localStorage).</li>
          <li><strong>Login Status:</strong> We store your login status locally in your browser (using localStorage) to manage access to paid features.</li>
          <li><strong>Cookies:</strong> We may use cookies or similar technologies to enhance your experience on our website.</li>
          <li><strong>Analytics:</strong> We may use third-party analytics services (e.g., Azure Application Insights) to collect information about how you use our website.</li>
      </ul>

      <h2>How We Use Your Information</h2>

      <p>We use the information we collect for various purposes, including:</p>

      <ul>
          <li><strong>Account Management:</strong> To create and manage your account.</li>
          <li><strong>Voucher Code Delivery:</strong> To send you voucher codes via email.</li>
          <li><strong>Payment Processing:</strong> To process payments through Paystack.</li>
          <li><strong>Access Control:</strong> To manage access to different parts of our website based on your payment status and selected plan.</li>
          <li><strong>Communication:</strong> To communicate with you about your account, updates, and other relevant information.</li>
          <li><strong>Customer Support:</strong> To provide customer support and respond to your inquiries.</li>
          <li><strong>Improvement of Services:</strong> To improve our website and services.</li>
          <li><strong>Marketing:</strong> With your consent, we may send you promotional emails. You can opt out of these at any time.</li>
      </ul>

      <h2>Data Security</h2>

      <p>We take reasonable measures to protect your information from unauthorised access, use, or disclosure. These measures include:</p>

      <ul>
          <li><strong>Microsoft Identity Platform (Azure AD B2C):</strong> We use Microsoft's identity platform to securely manage user authentication and passwords.</li>
          <li><strong>Paystack:</strong> We rely on Paystack's secure payment processing system.</li>
          <li><strong>Azure Cosmos DB:</strong> We store voucher codes and user email associations in Azure Cosmos DB, a secure database.</li>
          <li><strong>localStorage:</strong> We use localStorage to store payment status, paid plan, and reference information temporarily in your browser.</li>
      </ul>

      <h2>Third-Party Services</h2>

      <p>We use the following third-party services:</p>

      <ul>
          <li><strong>Microsoft Identity Platform (Azure AD B2C):</strong> For user authentication.</li>
          <li><strong>Azure Cosmos DB:</strong> For our database.</li>
          <li><strong>Paystack:</strong> For payment processing.</li>
          <li><strong>Nodemailer:</strong> For sending emails.</li>
          <li><strong>Azure Application Insights:</strong> (If applicable) For website analytics.</li>
      </ul>

      <h2>Your Rights</h2>

      <p>You have the following rights regarding your personal information:</p>

      <ul>
          <li><strong>Access:</strong> You can request access to the personal information we hold about you.</li>
          <li><strong>Correction:</strong> You can request that we correct any inaccuracies in your personal information.</li>
          <li><strong>Deletion:</strong> You can request that we delete your personal information.</li>
          <li><strong>Opt-Out:</strong> You can opt out of receiving marketing communications from us.</li>
      </ul>

      <h2>Cookies</h2>

      <p>We may use cookies or similar technologies to enhance your experience on our website. You can control the use of cookies through your browser settings.</p>

      <h2>Changes to This Privacy Policy</h2>

      <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>

      <h2>Contact Us</h2>

      <p>If you have any questions about this Privacy Policy, please contact us at: <a href="mailto:info@edgeneonline.com">info@edgeneonline.com</a></p>
    </div>
  );
};

export default PrivacyPolicy;
